// extracted by mini-css-extract-plugin
export var wordContainer = "_rw-0";